import { loader } from "../assets";

const Loader = () => (
  <div className="flex justify-center items-center h-96">
    <img src={loader} alt="Loader" />
  </div>
);

export default Loader;
